import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/core/services/toast-service.service';
@Component({
  selector: 'app-enter-password-modal',
  templateUrl: './enter-password-modal.component.html',
  styleUrls: ['./enter-password-modal.component.scss'],
})
export class EnterPasswordModalComponent {
  public form!: FormGroup;
  public showValidationErrors = false;

  // Optional caller-supplied context shown above the password field (e.g. a
  // financial-action disclosure). Defaults empty, so every existing caller that
  // only sets `.action`/reads the result is unchanged and shows no extra copy.
  public message: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    public fb: FormBuilder,
    private toastService: ToastService
  ) {
    this.form = this.fb.group({
      password: [
        '',
        [
          Validators.required,
          ,
          Validators.minLength(6),
        ],
      ],
    });
  }

  submitPassword() {
    if (!this.form.valid) {
      this.showValidationErrors = true;
      return;
    }

    this.activeModal.close(this.form.get('password')?.value ?? '');
  }
}
